import React, { useState } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { ServiceAreasSection } from './components/ServiceAreasSection';
import { WhyPanchosSection } from './components/WhyPanchosSection';
import { SeasonalCalendar } from './components/SeasonalCalendar';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { PrivacyModal } from './components/PrivacyModal';
import { TermsModal } from './components/TermsModal';
import { FloatingButtons } from './components/FloatingButtons';
export function App() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <div className="min-h-screen bg-cream-100 font-body selection:bg-forest-500 selection:text-white" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <GallerySection data-id="element-6" />
        <ServiceAreasSection data-id="element-7" />
        <WhyPanchosSection data-id="element-8" />
        <SeasonalCalendar data-id="element-9" />
        <CTASection data-id="element-10" />
      </main>

      <Footer onOpenPrivacy={() => setIsPrivacyOpen(true)} onOpenTerms={() => setIsTermsOpen(true)} data-id="element-11" />

      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} data-id="element-12" />

      <TermsModal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} data-id="element-13" />

      <FloatingButtons data-id="element-14" />
    </div>;
}